import { requestSignOut } from "application/auth/authActions";
import React from "react";
import { useDispatch } from "react-redux";

export const LogoutLink = ({ text, ...props }) => {
  const dispatch = useDispatch();

  const onClick = e => {
    e.preventDefault();
    dispatch(requestSignOut());
  };

  return (
    <a href="/" onClick={onClick} data-cy="HeaderLogoutLink" {...props}>
      <span>{text}</span>
    </a>
  );
};
